// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_am-0";
export var optionCard = "_am-1";